import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import Button from '../../../../Button';
import Textarea from '../../../../Input/components/Textarea';
import { useRatingForm } from './RatingForm.hooks';
import {
  CategoryContainer,
  Category,
  FieldLabel,
  FieldDescription,
  RatingFormContainer,
  SubmitButtonContainer,
  ErrorMessage,
} from './RatingForm.styled';
import { RatingFormProps } from './RatingForm.interface';

const commentValidation = {
  maxLength: 500,
};

const RatingForm: FunctionComponent<RatingFormProps> = (props) => {
  const {
    globalConfig: { config: widgetConfigs },
    lastRating,
    onRateSuccess,
  } = props;
  const { t } = useTranslation();
  const { rating } = widgetConfigs;
  const {
    comment,
    onChangeComment,
    categories,
    onClickCategory,
    onSubmit,
    error,
  } = useRatingForm(widgetConfigs, lastRating, { onRateSuccess });
  const commentFieldLabel =
    rating.additionalQuestion || t('RATING_ADDITIONAL_QUESTION');
  const commentFieldPlaceholder =
    rating.additionalQuestionPlaceholder ||
    t('RATING_ADDITIONAL_QUESTION_PLACEHOLDER');
  const hasCategory = !!categories.length;

  return (
    <RatingFormContainer>
      {hasCategory && (
        <CategoryContainer>
          {categories.map((category) => {
            const { label, selected } = category;
            return (
              <Category
                role="checkbox"
                aria-checked={selected}
                variant={selected ? 'fulfilled' : 'outlined'}
                onClick={() => onClickCategory(category)}
              >
                {label}
              </Category>
            );
          })}
        </CategoryContainer>
      )}

      <FieldLabel>
        {commentFieldLabel}{' '}
        <FieldDescription>({t('FIELD_OPTIONAL')})</FieldDescription>
      </FieldLabel>
      <Textarea
        rows={6}
        placeholder={commentFieldPlaceholder}
        value={comment}
        onChange={(e) => {
          onChangeComment(e.currentTarget.value);
        }}
        maxLength={commentValidation.maxLength}
      />

      <SubmitButtonContainer>
        <Button onClick={onSubmit}>{t('BUTTON_SUBMIT')}</Button>
        {error && <ErrorMessage>{t('ERROR_MSG_GENERAL')}</ErrorMessage>}
      </SubmitButtonContainer>
    </RatingFormContainer>
  );
};

export default RatingForm;
